function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import { Tooltip } from 'reactstrap';
import clsx from 'clsx';
import { FiInfo } from 'react-icons/fi';
import useStore from '../store';
import { UNTD_STATIC_LAYERS } from './../../../../constants/layers';
import { ROUTE_SET } from './../../../../constants/map';
/**
 * Provides toggle functionality for provided array of layer objects
 */

var MapLayerToggle = function MapLayerToggle(_ref) {
  var props = _extends({}, _ref); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var activeStaticLayers = useStore(function (state) {
    return state.activeStaticLayers;
  }); // console.log('activeStaticLayers, ', activeStaticLayers)

  var getLayerLabel = function getLayerLabel(id) {
    var layer = UNTD_STATIC_LAYERS.find(function (gr) {
      return gr.id === id;
    });
    return layer.label;
  };

  var updateLayers = function updateLayers(e) {
    // console.log('updateLayers, ', e.currentTarget)
    // Get index of control
    var index = Number(String(e.currentTarget.id).replace('layer_static_', '')); // console.log('index: ', index)

    var newStaticLayers = activeStaticLayers.slice().map(function (el, i) {
      if (i === index) {
        // return el == 1 ? 0 : 1
        return 1;
      } else {
        return 0;
      }
    });
    setStoreValues({
      activeStaticLayers: newStaticLayers
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "map-layer-toggle"
  }, UNTD_STATIC_LAYERS.map(function (el, i) {
    // to manage tooltip state
    var _useState = useState(false),
        tooltipOpen = _useState[0],
        setTooltipOpen = _useState[1];

    var toggle = function toggle() {
      return setTooltipOpen(!tooltipOpen);
    };

    return /*#__PURE__*/React.createElement("label", {
      key: "label-" + el.id,
      id: "label-" + el.id
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      id: 'layer_static_' + i,
      name: "scales",
      key: el.id,
      "data-only-one": el.only_one,
      "data-only-one-name": el.only_one_name,
      checked: activeStaticLayers[i] === 1 ? true : false,
      readOnly: true,
      onClick: function onClick(e) {
        updateLayers(e);
      }
    }), /*#__PURE__*/React.createElement("span", null, i18n.translate(getLayerLabel(el.id))), !!el.tooltip && el.tooltip.length > 0 && /*#__PURE__*/React.createElement(FiInfo, {
      id: 'tip_prompt_' + el.id
    }));
  }));
};

export default MapLayerToggle;